export const getFormInitialValues = (fields, contactFields) => {
  const form = fields.reduce((result, field) => {
    const componentNameWithoutPrefix = field.__component.replace('form.', '');

    if (componentNameWithoutPrefix === 'select' || componentNameWithoutPrefix === 'radio') {
      const defaultValue = field.initialValue || field.options.split('\n')[0] || '';
      result[field.label] = defaultValue;
    } else if (componentNameWithoutPrefix === 'multiple-choice') {
      result[field.label] = []; // Set checkbox initial value to empty array
    } else if (componentNameWithoutPrefix === 'checkbox') {
      result[field.label] = false; // Set checkbox initial value to false
    } else {
      result[field.label] = field.initialValue || '';
    }

    if (componentNameWithoutPrefix === 'number') {
      result[field.label] = field.startValue; // TODO: Rename initialValue for consistency
    }

    return result;
  }, {});

  const contact = contactFields
    ? contactFields.reduce((result, currentKey) => {
        result[currentKey] = '';
        return result;
      }, {})
    : {};

  return {
    form,
    contact,
    tacCheckbox: false,
  };
};
